// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';
import ProjectActions from '../actions/project.actions';
import WizardActions from '../actions/wizard.actions';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';
import Checkbox from 'react-toolbox/lib/checkbox';
import MdAddCircleOutline from 'react-icons/lib/md/add-circle-outline';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import qs from 'query-string';
import { routerActions } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';
import Button from '../common/ButtonComp';
import ArrowRight from 'react-icons/lib/md/keyboard-arrow-right';
import './CreateUploadPropertyComp.css';

class CreateUploadPropertyComp extends Component {
  state: {
    customPropertyName: string,
    customPropertyName_valid: boolean,
    accountId: string,
    isEditableAccount: boolean,
    acceptedToc: boolean,
    territory: '',
    country: ''
  };

  constructor(props) {
    super(props);

    this.state = {
      customPropertyName: '',
      accountId: props.project && props.project.accountId,
      isEditableAccount: true,
      customPropertyName_valid: false,
      acceptedToc: props.me.user.tocAccepted || false,
      territory: (props.project && props.project.territory) || '',
      country: (props.project && props.project.country) || ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.accounts === nextProps.accounts) return;

    const { accountId } = this.state;

    const account = !accountId
      ? nextProps.accounts[0]
      : getAccountById({ accounts: nextProps.accounts, accountId });

    if (!account) return;

    const permissions = account.permissions.effective;
    const isEditableAccount = !!~permissions.indexOf('EDIT');

    this.setState({ accountId: account.id, isEditableAccount });
  }

  selectAccount(account) {
    const {
      projectActions: { getWebProperties },
      project
    } = this.props;

    const permissions = account.permissions.effective;
    const isEditableAccount = !!~permissions.indexOf('EDIT');

    this.setState({ accountId: account.id, isEditableAccount });

    if (isEditableAccount) {
      getWebProperties({ id: project._id, accountId: account.id });
    }
  }

  createAccount() {
    const {
      projectActions: { createWebProperty },
      project,
      routerActions,
      query: { idx }
    } = this.props;
    const { accountId, customPropertyName, territory, country } = this.state;
    const cb = (data) => routerActions.push(`select-plan?idx=${idx}`);
    createWebProperty({
      id: project._id,
      accountId,
      cb,
      data: { customPropertyName, territory, country }
    });
  }

  handleChange = (name, value) => {
    let isValid = /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]?(?:\.[a-zA-Z]{2,})+$/.test(
      value.trim()
    );
    this.setState({ [name]: value.trim(), [`${name}_valid`]: isValid });
  };
  handleTerritoryChangeDropdown = (territory) => {
    this.setState({ territory });
  };
  handleCountryChangeDropdown = (country) => {
    this.setState({ country, territory: '' });
  };

  handleChangeDropdown = (tokenId) => {
    const {
      wizardActions: { selectAccount },
      project
    } = this.props;

    if (tokenId === 'add') {
      window.location.href = `/auth/with-google/add?projectId=${project._id}&projectIndex=${
        project.index
      }`;
      return;
    }

    this.setState({ accountId: null });
    selectAccount({ tid: tokenId, projectId: project._id, accountId: project.accountId });
  };

  goNext = () => {
    const {
      query: { idx = 0 }
    } = this.props;

    this.props.routerActions.push(`select-plan?idx=${idx}`);
  };

  componentDidMount() {
    const {
      projectActions: { getAccounts, getWebProperties },
      project,
      projects,
      me: { user }
    } = this.props;
    const cb = (data) => {
      if (data && data[0] && data[0].id && !project.accountId) {
        this.setState({ accountId: data[0].id });
        getWebProperties({ id: project._id, accountId: data[0].id });
      }
    };
    getAccounts({ id: project._id, cb });
    if (project.accountId) getWebProperties({ id: project._id, accountId: project.accountId });
  }

  toggleTOC = () => {
    const {
      me: { user }
    } = this.props;

    if (user.tocAccepted) {
      return;
    }

    this.setState({
      acceptedToc: !this.state.acceptedToc
    });
  };

  render() {
    const {
      translate,
      project,
      webProperties,
      webPropertiesError,
      webPropertiesUpdating,
      webPropertiesCreating,
      accounts,
      accountsUpdating,
      accountsError,
      me,
      isFirstProject,
      territoriesList,
      countries
    } = this.props;
    const {
      acceptedToc,
      isEditableAccount,
      customPropertyName_valid,
      customPropertyName
    } = this.state;
    const props = this.props;
    const isUploadAccountExists = !!project.webPropertyId;
    let originalPropertyName = 'Log Hero';

    const accountsUpdatingProgress = accountsUpdating && (
      <ProgressBar type="linear" mode="indeterminate" />
    );
    const webPropertiesUpdatingProgress = webPropertiesUpdating && (
      <ProgressBar type="linear" mode="indeterminate" />
    );

    const inactiveProps = webProperties.filter((p) => p.id !== project.webPropertyId);
    const activeProps = webProperties.filter((p) => p.id === project.webPropertyId);

    const newWebPropertyPlaceholderClassName = [
      customPropertyName && !customPropertyName_valid ? 'invalid' : '',
      'select-list_new'
    ].join(' ');

    const newWebPropertyPlaceholder = (
      <div className={newWebPropertyPlaceholderClassName}>
        <MdAddCircleOutline className="circle-icon" />
        <span>
          <Input
            className="select-list_new-prop-name"
            type="text"
            hint={translate('wizard.create_upload_account.custom_prop_name')}
            value={customPropertyName}
            onChange={this.handleChange.bind(this, 'customPropertyName')}
          />{' '}
          - {originalPropertyName}
        </span>
        <div className="select-list_new_error">Please enter proper domain name!</div>
      </div>
    );

    const accountsErrorMessage = (webPropertiesError || accountsError) &&
      !accountsUpdating && (
        <p>
          {translate('wizard.create_upload_account.account_access_error', {
            appAccEmail: project.accessEmail,
            projectId: project._id,
            projectIndex: project.index,
            consent: true
          })}
        </p>
      );

    const propertiesErrorMessage = !isEditableAccount &&
      !webPropertiesUpdating && (
        <p>
          {translate('wizard.create_upload_account.account_permissions_error', {
            stateAccountId: this.state.accountId,
            appAccEmail: project.accessEmail
          })}
        </p>
      );

    const newPropertyPlaceholderComp =
      !accountsUpdating &&
      !webPropertiesUpdating &&
      !isUploadAccountExists &&
      newWebPropertyPlaceholder;

    const activeProprsComp =
      isUploadAccountExists &&
      !accountsUpdating &&
      !webPropertiesUpdating &&
      activeProps.map(AnalyticsWebPropertiesSelectList.bind(this));

    const inactivePropsComp =
      !webPropertiesUpdating &&
      inactiveProps.slice(0, 4).map(AnalyticsWebPropertiesSelectList.bind(this));

    const selectList = (newPropertyPlaceholderComp, activeProprsComp, inactivePropsComp);

    const createNewAccount = (
      <Row start="xs" className="space-big-bottom">
        <Col xs={4}>
          <h5>{translate('wizard.create_upload_account.accounts')}</h5>
          <div className="select-list">
            {accountsUpdatingProgress}
            {!accountsError &&
              !accountsUpdating &&
              accounts.map(AnalyticsAccountsSelectList.bind(this))}
          </div>
        </Col>
        <Col xs={7}>
          <h5>{translate('wizard.create_upload_account.properties_apps')}</h5>
          <div className="select-list">
            {webPropertiesUpdatingProgress}
            {!accountsUpdating &&
              !webPropertiesError &&
              (accountsErrorMessage || propertiesErrorMessage)}
            {!accountsError &&
              !accountsUpdating &&
              !webPropertiesError &&
              !webPropertiesUpdating &&
              isEditableAccount && (
                <div>
                  {newPropertyPlaceholderComp}
                  {activeProprsComp}
                  {inactivePropsComp}
                </div>
              )}
          </div>
        </Col>
      </Row>
    );

    const next = (
      <Button big primary onClick={this.goNext.bind(this)}>
        {translate('app.next')}
      </Button>
    );
    const create = (
      <Button
        big
        primary
        loading={webPropertiesCreating}
        disabled={
          (!me.user.tocAccepted && !acceptedToc) ||
          accountsUpdating ||
          webPropertiesUpdating ||
          !this.state.territory ||
          !customPropertyName ||
          !customPropertyName_valid
        }
        onClick={this.createAccount.bind(this)}
      >
        {translate('app.create')}
      </Button>
    );

    const toc = !project.accountId &&
      (isFirstProject || !me.user.tocAccepted) && (
        <div className="wizard-property_setup-toc">
          <Row>
            <Col xsOffset={3} xs={8}>
              <Checkbox
                checked={acceptedToc}
                disabled={me.user.tocAccepted}
                theme={{ check: 'toc-checkbox', checked: 'toc-checkbox-checked' }}
                onChange={this.toggleTOC}
              >
                {translate('wizard.create_upload_account.toc_agree')}
              </Checkbox>
            </Col>
            {/* <Col xs={7}></Col> */}
          </Row>
        </div>
      );

    const accountList = me.user.googleAccounts.map(({ _id, email }) => ({
      value: _id,
      label: email
    }));

    accountList.push({
      value: 'add',
      label: translate('wizard.create_upload_account.change_account')
    });

    const selectedCountry = countries.country.filter(
      (c) => this.state.country === c.countryCode
    )[0];

    const timezones = [{ value: '', label: 'Select Timezone' }].concat(
      selectedCountry
        ? selectedCountry.timeZone.map((t) => ({ value: t.timeZoneId, label: t.displayName }))
        : []
    );

    const selectTerritory = (
      <Row>
        <Col xsOffset={3} xs={3}>
          <Dropdown
            auto
            disabled={project && project.country}
            onChange={this.handleCountryChangeDropdown}
            source={[{ value: '', label: 'Select Country' }].concat(
              countries.country.map((t) => ({ value: t.countryCode, label: t.displayName }))
            )}
            value={this.state.country}
          />
        </Col>
        <Col xs={3}>
          <Dropdown
            auto
            disabled={this.state.country === '' || (project && project.territory)}
            onChange={this.handleTerritoryChangeDropdown}
            source={timezones}
            value={this.state.territory}
          />
        </Col>
      </Row>
    );

    return (
      <div className="wizard-upload_create">
        <h1>{translate('wizard.create_upload_account.create_mirror')}</h1>
        <div className="space-big-bottom account-lead-text">
          {translate('wizard.create_upload_account.create_mirror_user_for')}

          {project.accountId ? (
            <strong> {project.accessEmail}</strong>
          ) : (
            <Col className="accounts-dropdown-wrapper" xs={5}>
              <Dropdown
                auto
                onChange={this.handleChangeDropdown}
                className={'accounts-dropdown'}
                template={DropdownAccountItem(me.user.googleSelectedToken)}
                source={accountList}
                value={me.user.googleSelectedToken}
              />
            </Col>
          )}

          {translate('wizard.create_upload_account.create_mirror_select_account')}
        </div>
        {createNewAccount}
        {selectTerritory}
        {toc}
        <div className="kwh-button-group">{isUploadAccountExists ? next : create}</div>
      </div>
    );
  }
}

function DropdownAccountItem(selectedValue) {
  return ({ value, label }) => {
    return (
      <div className={`dropdown-container ${value === 'add' && 'dropdown-change-element'}`}>
        <div className={`content-element ${value === selectedValue && 'active'}`}>{label}</div>
      </div>
    );
  };
}

function AnalyticsAccountsSelectList(account, i) {
  const { project } = this.props;
  const isUploadAccountExists = !!project.webPropertyId;
  const isActiveAccount = this.state.accountId === account.id || project.accountId === account.id;
  const itemClassName = [
    'select-list_item',
    isUploadAccountExists && !isActiveAccount ? 'select-list_faded' : '',
    isActiveAccount ? 'active' : ''
  ].join(' ');
  const onClickAction =
    !isUploadAccountExists && !isActiveAccount && this.selectAccount.bind(this, account);
  return (
    <div className={itemClassName} onClick={onClickAction} key={i}>
      {account.name} <ArrowRight className="select-list_arrow" />
    </div>
  );
}

function AnalyticsWebPropertiesSelectList(property, i) {
  const { project } = this.props;
  const isActiveAccount = project.webPropertyId === property.id;
  const itemClassName = ['select-list_item', isActiveAccount ? 'active' : 'select-list_faded'].join(
    ' '
  );
  return (
    <div className={itemClassName} key={i}>
      <span>{property.name}</span> <small>{property.id}</small>
    </div>
  );
}

function getAccountById({ accounts, accountId }) {
  const matchedAccount = accounts.filter((account) => account.id === accountId);
  return matchedAccount && matchedAccount[0];
}

function mapStateToProps(state) {
  const {
    routing: {
      location: { search }
    },
    project: {
      accounts,
      webProperties,
      accountsUpdating,
      webPropertiesUpdating,
      webPropertiesCreating,
      accountsError,
      webPropertiesError,
      countries
    }
  } = state;
  const query = search ? qs.parse(search) : { idx: 0 };
  const { projects = [] } = state.me.user;
  const project = projects.find(({ index }) => index == query.idx);
  const isFirstProject =
    project && projects[projects.length - 1] && projects[projects.length - 1]._id === project._id;
  return {
    me: state.me,
    wizard: state.wizard,
    translate: getTranslate(state.locale),
    project,
    projects,
    query,
    accounts,
    webProperties,
    webPropertiesError,
    accountsError,
    countries,
    accountsUpdating,
    webPropertiesUpdating,
    webPropertiesCreating,
    isFirstProject
  };
}

function mapDispatchToProps(dispatch) {
  return {
    wizardActions: bindActionCreators(WizardActions, dispatch),
    projectActions: bindActionCreators(ProjectActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUploadPropertyComp);



// WEBPACK FOOTER //
// ./src/wizard/CreateUploadPropertyComp.js